export default __webpack_public_path__ + "static/thumbnail_darkmode_updated-0dd2671cdff7baba9a5be57ad7a707eb.png";